import React, { useState } from 'react';

import './tweetimage.scss';

export default ({ src, configStyle, imageActive = true }) => {
  const [loaded, setLoaded] = useState(false);

  const imageOnLoad = () => {
    setLoaded(true);
  };

  if (['split-screen-animated', 'split-screen-no-animation'].includes(configStyle)) {
    return (
      <div
        className="tweet-image__wrapper"
        style={{ opacity: imageActive ? 1 : 0, transition: 'opacity 0.3s ease' }}
      >
        <div
          className={`tweet__media-background ${loaded ? 'tweet__media-background--loaded' : ''}`}
          style={{ backgroundImage: `url(${src})`, backgroundSize: 'cover' }}
        ></div>
        <div
          style={{
            backgroundImage: `url(${src})`
          }}
          className={`tweet-image ${loaded ? 'tweet-image--loaded' : ''}`}
        ></div>
        <img onLoad={imageOnLoad} src={src} />
      </div>
    );
  }

  return (
    <img
      className={`tweet-image ${loaded ? 'tweet-image--loaded' : ''}`}
      onLoad={imageOnLoad}
      src={src}
    />
  );
};
